module.exports = __webpack_public_path__ + "img/bg_1.1094b5e0.jpg";